declare var bootbox: any;
class WorkbookCopy {
    originalWorkbookId: number;
    originalWorkbookName: string;

    workbookCopyId: number;
    workbookCopyName: string;

    copyDate: string;
    dateModification: string;

    ownerId: number;
    ownerName: string;

    constructor() {

    }
}

class WorkbookCopyViewModel {
    workbookCopies: Array<WorkbookCopy>;
    originalWorkbook: Array<WorkbookCopy>;
    tabSettings: any;

    constructor() {
        this.workbookCopies = [];
        this.originalWorkbook = [];
    }
}

var workbookCopies = (function () {
    function setup(data, element: JQuery<HTMLElement>) {
        let vm = new WorkbookCopyViewModel();
        data.workbookCopies.forEach(function (wb) {
            let workbookCopy = new WorkbookCopy();
            Object.assign(workbookCopy, wb);
            vm.workbookCopies.push(workbookCopy);
        });
        data.originalWorkbook.forEach(function (wb) {
            let originalWb = new WorkbookCopy();
            Object.assign(originalWb, wb);
            vm.originalWorkbook.push(originalWb);
        });

        let dataSource = [{
            name: "Workbook Copies",
            visible: vm.workbookCopies.length > 0 || vm.originalWorkbook.length === 0,
            dataSource: vm.workbookCopies
        },
        {
            name: "Original Workbook",
            visible: vm.originalWorkbook.length > 0,
            dataSource: vm.originalWorkbook
        }];

        vm.tabSettings = {
            height: '100%',
            width: '100%',
            activeStateEnabled: true,
            selectedIndex: vm.originalWorkbook.length > 0 && vm.workbookCopies.length > 0 ? 0 : vm.originalWorkbook.length > 0 ? 1 : 0,
            dataSource: dataSource,
            itemTitleTemplate: function (data, index, element) {
                return data.name;
            },
            itemTemplate: function (data, index, element) {
                element.dxDataGrid({
                    height: "100%",
                    dataSource: data.dataSource,
                    columns: [
                        { dataField: "ownerName", caption: "Owner" },
                        { dataField: "workbookName", caption: "Workbook" },
                        {
                            dataField: "dateModification",
                            caption: "Date Modification",
                            dataType: "datetime",
                            customizeText(cellInfo) {
                                return formatDateTime(cellInfo.value)
                            },
                            width: isMobile() ? undefined : 130
                        },
                        {
                            dataField: "copyDate",
                            caption: "Copy Date",
                            dataType: "datetime",
                            customizeText(cellInfo) {
                                return formatDateTime(cellInfo.value)
                            },
                            width: isMobile() ? undefined : 130
                        },
                        {
                            type: 'buttons',
                            width: 50,
                            buttons: [{
                                hint: 'Open workbook',
                                icon: 'link',
                                onClick(e) {
                                    if (e.row.data.hasAccess || loggedUser.permissions.workbooks()) {
                                        window.open(`${window.location.origin}/wb/edit/${e.row.data.workbookId}`, '_blank').focus();
                                    }
                                    else {
                                        DevExpress.ui.dialog.alert("No access to workbook", "");
                                    }
                                }
                            }],
                        }
                    ]
                });
            }
        }

        let div = $(`<div id="WorkbookCopiesPopupContent" style="height: 100%"><div data-bind='dxTabPanel: tabSettings'></div></div>`).appendTo(element);
        ko.applyBindings(vm, div[0]);

        if (dataSource.filter(x => x.visible).length === 1) {
            $(".dx-tabs-wrapper", div).css("display", "none");
        }
    }

    return {
        setup: setup
    };
}());